import { Grid } from "@material-ui/core";
import React from "react";
import { INode } from "../types";

export interface ISearchResultProps {
  result: INode;
}

const SearchResult: React.FC<ISearchResultProps> = (props) => {
  const { result } = props;

  return (
    <div>
      <Grid container>
        <Grid item xs>
          <div>{`${result.Name} (${result.ObjectNumber})`}</div>
        </Grid>
      </Grid>
    </div>
  );
};

export default SearchResult;
